import React, { useMemo } from "react";
import { NavLink, useLocation } from "react-router-dom";

const ROUTE_MAP = [
  { path: "/admin/overview", section: "Admin Overview" },
  { path: "/admin/master-data", section: "Master Data" },
  { path: "/admin/users", section: "Users" },
  { path: "/admin/users/:id", section: "Users", detail: "User Detail" },
  { path: "/admin/billing/transactions", section: "Billing Transactions" },
  {
    path: "/admin/billing/transactions/:id",
    section: "Billing Transactions",
    detail: "Transaction Detail",
  },
  { path: "/admin/reports/status", section: "Reports Status" },
  { path: "/admin/analysis/errors", section: "Analysis Errors" },
];

const matchRoute = (pathname) => {
  const direct = ROUTE_MAP.find((route) => route.path === pathname);
  if (direct) return direct;
  return ROUTE_MAP.find((route) => {
    if (!route.path.includes(":")) return false;
    const base = route.path.split("/:")[0];
    return pathname.startsWith(`${base}/`);
  });
};

export default function AdminBreadcrumbs() {
  const location = useLocation();
  const route = useMemo(
    () => matchRoute(location.pathname || ""),
    [location.pathname]
  );

  const crumbs = useMemo(() => {
    if (!route) {
      return [{ label: "Admin Overview", to: "/admin/overview" }];
    }
    if (route.path === "/admin/overview") {
      return [{ label: "Admin Overview", to: "/admin/overview", current: true }];
    }
    const listCrumbs = [
      { label: "Admin Overview", to: "/admin/overview" },
      { label: route.section, to: route.path.replace(/\/:.*$/, "") },
    ];
    if (route.detail) {
      listCrumbs.push({ label: route.detail, current: true });
      return listCrumbs;
    }
    return listCrumbs.map((crumb, index) => ({
      ...crumb,
      current: index === listCrumbs.length - 1,
    }));
  }, [route]);

  return (
    <nav aria-label="breadcrumb">
      <ol className="flex flex-wrap items-center gap-2 text-sm text-slate-500">
        {crumbs.map((crumb, index) => (
          <li key={`${crumb.label}-${index}`} className="flex items-center gap-2">
            {crumb.current ? (
              <span className="max-w-[180px] truncate text-slate-700">
                {crumb.label}
              </span>
            ) : (
              <NavLink className="text-amber-600 hover:text-amber-500" to={crumb.to}>
                {crumb.label}
              </NavLink>
            )}
            {index < crumbs.length - 1 && <span>→</span>}
          </li>
        ))}
      </ol>
    </nav>
  );
}
